import axios from "axios";

class DataFetcher {


  axiosAdapter = axios.create({
    baseURL: process.env.REACT_APP_BACKENDURL,
    timeout: 5000
  });


  async fetchUrl(url) {
    try {
      return await this.axiosAdapter.get(url);
    } catch (e) {
      console.log('Error fetching data: ' + e);
      return false;
    }
  }
}

export let dataFetcher = new DataFetcher();
